import { render, staticRenderFns } from "./Avatars.vue?vue&type=template&id=172bd494&scoped=true&"
import script from "./Avatars.vue?vue&type=script&lang=js&"
export * from "./Avatars.vue?vue&type=script&lang=js&"
import style0 from "./Avatars.vue?vue&type=style&index=0&id=172bd494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172bd494",
  null
  
)

export default component.exports